export default __webpack_public_path__ + "static/media/triangle.0934b4da.svg";